<template>
  <div class="teacher">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="teacherName" placeholder="请输入姓名" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-button type="primary" @click="handleAdd">新增专家</el-button>
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="80" show-overflow-tooltip prop="teacherName" label="姓名"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="phoneNum" label="联系电话"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userAccount" label="登录账号"></el-table-column>
          <!-- <el-table-column min-width="100" show-overflow-tooltip prop="userPassword" label="密码"></el-table-column> -->
          <el-table-column min-width="100" show-overflow-tooltip prop="status" label="账号状态" header-align="center"
            align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.switchStatus" active-color="#A32126" @change="handleSwitch(scope.row)"
                :key="scope.row.id">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="160">
            <template slot-scope="scope">
              <el-button class="btn" type="" size="" plain @click="handleEdit(scope.row)">修改</el-button>
              <el-button class="btn" type="danger" size="" plain @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>

    <el-dialog :title="isAdd ? '新增' : '修改'" :visible.sync="dialogVisible" width="60%" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="ruleForm">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form-item label="姓名" prop="userName">
              <el-input v-model.trim="ruleForm.userName" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="登录账号" prop="userAccount">
              <el-input v-model.trim="ruleForm.userAccount" placeholder="请输入登录账号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="联系电话" prop="phoneNum">
              <el-input v-model.trim="ruleForm.phoneNum" placeholder="请输入联系电话" clearable></el-input>
            </el-form-item>
            <el-form-item label="登录密码" prop="userPassword">
              <el-input v-if="isAdd" v-model.trim="ruleForm.userPassword" placeholder="请输入登录密码" clearable></el-input>
              <el-input v-if="!isAdd" v-model.trim="ruleForm.userPassword" placeholder="请输入登录密码"
                @blur="userPasswordBlur(ruleForm.userPassword)"
                @focus="userPasswordFocus(ruleForm.userPassword)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="submitLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
function createInitRuleForm() {
  return {
    userName: "",
    phoneNum: "",
    userAccount: "",
    userPassword: "",
    status: "1", // 状态 (0:待审核 1:正常 2:审核不通过 3:停用 9:删除/失效)
  }
}
export default {
  data() {
    var checkTel = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("联系电话不能为空"))
      }
      const telRegex = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!telRegex.test(value)) {
        callback(new Error("联系电话格式不正确"))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      show: false,
      teacherName: "",
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）

      dialogVisible: false,
      isAdd: true,
      submitLoading: false,
      ruleForm: createInitRuleForm(),
      rules: {
        userName: [{ required: true, message: "请输入姓名", trigger: ["blur"] }],
        userAccount: [{ required: true, message: "请输入登录账号", trigger: ["blur"] }],
        userPassword: [{ required: true, message: "请输入登录密码", trigger: ["blur"] }],
        phoneNum: [{ required: true, validator: checkTel, trigger: ["blur"] }],
      },
    }
  },
  created() {
    this.getRequestList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.teacherList, {
          params: {
            teacherName: this.teacherName || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list.map((item) => {
            return {
              ...item,
              switchStatus: item.status == 3 ? false : item.status == 1 ? true : null
            }
          })
          this.totalCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 新增（对话框）
    handleAdd() {
      this.isAdd = true
      this.dialogVisible = true
    },
    // 修改（对话框）
    handleEdit(row) {
      this.isAdd = false
      this.$set(this.ruleForm, 'userName', row.teacherName)
      this.$set(this.ruleForm, 'phoneNum', row.phoneNum)
      this.$set(this.ruleForm, 'userAccount', row.userAccount)
      this.$set(this.ruleForm, 'userPassword', '******')
      this.$set(this.ruleForm, 'id', row.id)
      this.$set(this.ruleForm, 'status', row.status)
      this.$set(this.ruleForm, 'userId', row.userId)
      this.dialogVisible = true
    },
    // 密码获取焦点
    userPasswordFocus(userPassword) {
      if (userPassword == '******') {
        this.$set(this.ruleForm, 'userPassword', '')
      } else {
        this.$set(this.ruleForm, 'userPassword', userPassword)
      }
    },
    // 密码失去焦点
    userPasswordBlur(userPassword) {
      if (userPassword == '') {
        this.$set(this.ruleForm, 'userPassword', '******')
      } else {
        this.$set(this.ruleForm, 'userPassword', userPassword)
      }
    },
    // 删除
    handleDelete(row) {
      this.$confirm("即将删除该专家, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.teacherStatus, {
              id: row.id,
              status: 9
            })
            .then(res => {
              if (res.code == 100) {
                this.$message.success("删除成功")
                this.getRequestList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {

        })
    },
    // 账号状态设置
    handleSwitch(row) {
      let ins = row.status == 1 ? '停用' : '启用'
      this.$axios
        .post(this.$api.teacherStatus, {
          id: row.id,
          status: row.status == 1 ? 3 : 1
        })
        .then(res => {
          if (res.code == 100) {
            this.$message.success(`${ins}成功`)
            this.getRequestList()
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 提交表单
    submitForm(formName) {
      this.submitLoading = true
      let params = Object.assign({}, this.ruleForm)
      let api = ""
      let methods = ""
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            api = this.$api.teacherAdd
            methods = "post"
          } else {
            api = this.$api.teacherEdit
            methods = "post"
          }
          this.$axios[methods](api, params)
            .then(res => {
              this.$message.success(`${this.isAdd ? "新增" : "修改"}成功`)
              this.getRequestList()
              this.submitLoading = false
              this.dialogVisible = false
              this.resetForm()
            })
            .catch(err => {
              this.submitLoading = false
              this.$message.error(err.desc)
            })
        } else {
          this.submitLoading = false
          this.$message.error("提交失败")
          return false
        }
      })
    },
    // 重置校验
    resetForm() {
      this.ruleForm = createInitRuleForm()
      this.$refs.ruleForm.resetFields()
    },
    // 关闭对话框
    onCancel() {
      this.resetForm()
      this.dialogVisible = false
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.teacher {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }

  .eye {
    cursor: pointer;
    margin-left: 6px;

    img {
      display: inline-block;
    }
  }
}
</style>
